import React, { PureComponent } from 'react'
import { Button } from 'antd'
export default class maintain extends PureComponent {
    render() {
        this.pdToHome()
        return (
            <div className="jq-maintain-info center text-center">
                <div><img width="300px" src="img/maintain_icon.png" alt="" /></div>
                <p className="MB20">老板莫方，小玖正在火速升级中，更多功能敬请期待.....</p>
                <Button type="primary" onClick={()=>this.toHome()}>刷新</Button>
            </div>
        )
    }
    toHome(){
        location.reload()
    }
    pdToHome(){
        if(!window.maintainConfig||!window.maintainConfig.iotManagement){
            location.href = '#/'
        }
    }
}
